import { render, staticRenderFns } from "./main-message.vue?vue&type=template&id=80dc6f6e&scoped=true&"
import script from "./main-message.vue?vue&type=script&lang=js&"
export * from "./main-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dc6f6e",
  null
  
)

export default component.exports